import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityItemComponent } from './activity-item/activity-item.component';
import { SharedModule } from '../shared/shared.module';
import { ActivityRegistryComponent } from './activity-registry/activity-registry.component';
import { ActivityRegistryService } from './activity-registry-service/activity-registry.service';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [ActivityItemComponent, ActivityRegistryComponent],
  exports: [ActivityRegistryComponent],
  providers: [ActivityRegistryService],
})
export class ActivityRegistryModule {}



// WEBPACK FOOTER //
// ./ts/app/activity-registry/activity-registry.module.ts